import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { ICodeStockFilter } from "../models/filters/codeStockFilter";
import { ICodeStockForm } from "../models/forms/codeStockForm";
import { ICodeStockPDTO } from "../models/dtos/codeStockPDTO";

export default class CodeStockService extends _o2sService {

    protected static override mainUrl: string = API_CENTRE + "/api/v1/CodeStock";

    protected static override getUrlFilter<F extends ICodeStockFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);
        if (filter != null) {
            if (filter.code != undefined)
                url += `&Code=${filter.code}`;
            if (filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
        }
        return url;
    }

    public static override toDTO(obj: ICodeStockForm): ICodeStockPDTO {
        const dto = super.toDTO(obj) as ICodeStockPDTO;
        return dto;
    }
}
